"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomainNameForEnvironment = getDomainNameForEnvironment;
exports.buildFullyQualifiedUrl = buildFullyQualifiedUrl;
const Environment_1 = require("../enums/Environment");
const protocolFilter = /(^\w+:|^)\/\//;
const leadingAndTrailingSlashFilter = /^\/|\/$/g;
/**
 * Returns the base domain name for the given Insight environment
 *
 * @export
 * @param {Environment} env
 * @return {*}  {string}
 */
function getDomainNameForEnvironment(env) {
    switch (env) {
        case Environment_1.Environment.Dev:
            return 'monexinsight-dev.net';
        case Environment_1.Environment.QA:
            return 'monexinsight-qa.net';
        case Environment_1.Environment.Production:
        default:
            return 'monexinsight.net';
    }
}
/**
 * Returns a fully qualified URL for the provided domain and path.
 *
 * @export
 * @param {string} domain The base domain, such as "api.monexinsight.net"
 * @param {string} path The URL path, such as "market/flags/JP:8698-TS"
 * @param {boolean} [secure=true] Whether the URL should be secure or not, defaults to true
 * @return {string} The built URL
 */
function buildFullyQualifiedUrl(domain, path, secure = true) {
    // Remove any protocols (http://, https://, etc) from the base domain
    domain = domain.replace(protocolFilter, '');
    // Remove any trailing slashes from the domain
    domain = domain.replace(leadingAndTrailingSlashFilter, '');
    // Remove any leading or trailing slashes from the path
    path = path.replace(leadingAndTrailingSlashFilter, '');
    const protocol = secure ? 'https://' : 'http://';
    return `${protocol}${domain}/${path}`;
}
//# sourceMappingURL=url.js.map